'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="#FF4473" strokeLinecap="round" strokeWidth={2} d="M1.5 8h3M1.5 12h3M1.5 16h3" /><path fill="#FF4473" fillRule="evenodd" d="M3 3a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm7.5 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m4.906 2.75a4 4 0 1 0-5.811 0A6 6 0 0 0 6.5 18h2a4 4 0 0 1 8 0h2c0-2.26-1.25-4.227-3.094-5.25" clipRule="evenodd" /><rect width={19} height={22} x={3} y={1} stroke="#FF4473" strokeWidth={2} rx={2} /></svg>;
const IconContactsNavigationActive = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconContactsNavigationActive;